import styled from "styled-components";

import { Button, media } from "@otta/design";
import { pxToRem, palette } from "@otta/design-tokens";

export const DeleteButton = styled(Button)`
  color: red;
  border-color: red;
  background: ${palette.grayscale.shade50};
  margin: 0;

  :hover {
    color: ${palette.brand.red};
    border-color: ${palette.brand.red};
    background: ${palette.grayscale.shade100};
  }

  ${media({ to: "tablet" })`
    margin-top: ${pxToRem(8)};
  `}
`;
